module.exports = __webpack_public_path__ + "img/facebook-brands.2d7d3b93.svg";